import { Flex, Text, type TagsInputProps, type FlexProps } from '@mantine/core';
import classes from './FormTagsInputSkills.module.scss';
import { TagsInputSkills } from '../TagsInputSkills';

interface FormTagsInputSkillsProps extends TagsInputProps {
  title?: string;
  description?: string;
  containerProps?: FlexProps;
}

export const FormTagsInputSkills = ({
  title = 'Ключевые навыки',
  description = 'Выберите все необходимые ключевые навыки сотрудника',
  placeholder = 'Выберите',
  containerProps,
  ...props
}: FormTagsInputSkillsProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <TagsInputSkills
        {...props}
        placeholder={placeholder}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
